const generateScopedName = require("util/generate_scoped_name")

const scopeClasses = (filename, names) => names.map(n => generateScopedName(n, filename)).join(" ")
const classes = (filename) => (...names) => scopeClasses(filename, names)

// Use CommonJS/Node-style exports so this can be imported and invoked in one line
// like: const classes = require("util/classes")(__filename)
module.exports = classes
